<template>
  <div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="listaProdutos"
        :loading="loading"
        :rows-per-page-options="[0]"
        color="primary"
        dense
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        hide-pagination
        flat
        class="tabela-tamanho-fixo"
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.busca"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos os produtos criados</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span
                    style="white-space: normal"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.contract_product_description }}</span
                  >
                  <div class="row col-12">
                    <span v-if="!props.selected" class="row q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Categoria: </strong>
                      {{
                        props.row.contracts[0]?.pivot?.product_category?.code
                      }}</span
                    >
                    <span class="row q-ml-sm q-mt-sm" v-else
                      ><strong class="q-mr-xs">Categoria: </strong>
                      <select
                        v-model="categoriaGrid"
                        name="select"
                        class="select"
                      >
                        <option
                          v-for="(categoria, index) in categorias"
                          :value="categoria.value"
                          :key="index"
                        >
                          {{ categoria.label }}
                        </option>
                      </select>
                    </span>
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">CA: </strong>
                    {{
                      props.row.ca != null ? props.row.ca?.code : "Sem CA"
                    }}</span
                  >
                </div>
                <div class="col-4">
                  <div class="row justify-end">
                    <div v-if="!props.selected">
                      <q-btn
                        icon="done"
                        round
                        flat
                        color="positive"
                        @click="adicionarProdutoCatalogo(props.row)"
                      />
                      <q-btn
                        icon="edit"
                        round
                        flat
                        color="primary"
                        @click="
                          (props.selected = !props.selected),
                            (categoria = { label: 'Categoria', value: '' }),
                            (categoriaGrid = '')
                        "
                      />
                    </div>
                    <div v-else class="row justify-center">
                      <q-btn
                        class="q-mr-sm"
                        icon="close"
                        round
                        flat
                        color="negative"
                        @click="
                          (props.selected = !props.selected),
                            (categoria = { label: 'Categoria', value: '' }),
                            (selected = [])
                        "
                      />
                      <q-btn
                        icon="done"
                        round
                        flat
                        color="positive"
                        @click="adicionarProdutoCatalogo(props.row)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td style="white-space: normal">
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row.code }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <span> {{ props.row?.contract_product_description }}</span>
            </q-td>
            <q-td style="white-space: normal">
              <q-select
                v-if="props.selected"
                v-model="categoria"
                :options="categorias"
                dense
                outlined
                style="width: 130px"
              />
              <span v-else>
                {{
                  props.row.contracts[0]?.pivot?.product_category?.code
                }}</span
              >
            </q-td>
            <q-td style="white-space: normal">
              <span>
                {{ props.row.ca != null ? props.row.ca?.code : "Sem CA" }}</span
              >
            </q-td>
            <q-td style="white-space: normal">
              <div v-if="!props.selected" class="row justify-center no-wrap">
                <q-btn
                  icon="edit"
                  round
                  color="primary"
                  flat
                  @click="
                    (props.selected = !props.selected),
                      (categoria = { label: 'Categoria', value: '' })
                  "
                />
                <q-btn
                  icon="done"
                  flat
                  round
                  color="positive"
                  @click="adicionarProdutoCatalogo(props.row)"
                />
              </div>
              <div v-else class="row justify-center">
                <q-btn
                  class="q-mr-sm"
                  icon="close"
                  round
                  color="negative"
                  flat
                  @click="
                    (props.selected = !props.selected),
                      (categoria = { label: 'Categoria', value: '' }),
                      (selected = [])
                  "
                />
                <q-btn
                  icon="done"
                  round
                  flat
                  color="positive"
                  @click="adicionarProdutoCatalogo(props.row)"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    field: (row) => row?.contract_product_description,
    style: "white-space: normal",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ca",
    label: "CA",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "adicionar",
    label: "Adicionar",
    align: "center",
    style: "white-space: normal",
  },
];
export default {
  props: ["unidadeId", "tipoCatalogo", "atualizar"],
  emits: ["atualizarCatalogo"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const filtros = ref({ busca: "" });
    const listaProdutos = ref([]);
    const selected = ref([]);
    const categorias = ref([]);
    const categoriaGrid = ref("");
    const categoria = ref({
      label: "Categoria",
      value: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let loading = ref(false);
    let disable = ref(false);

    const listarProdutos = async (page = 0, rowsNumber = 6) => {
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("catalogo/listarTodosProdutos", {
          search: filtros.value.busca,
          page: page,
          per_page: rowsNumber,
        });
        listaProdutos.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarCategorias = async () => {
      categorias.value = [];
      const response = await store.dispatch("catalogo/listarCategorias");

      let array = response.data.results.data;
      array.forEach((categoria) => {
        categorias.value.push({
          label: categoria.code,
          value: categoria.id,
        });
      });
    };

    const adicionarProdutoCatalogo = async (produto) => {
      let categoriaId = categoria.value.value;
      let epi = undefined;
      if (props.tipoCatalogo == "sim") {
        epi = true;
      }
      if (screen.width < 600) {
        categoriaId = categoriaGrid.value;
      }
      try {
        await store.dispatch("catalogo/adicionarProdutoCatalogo", {
          catalog_id: props.unidadeId,
          ca_id:
            produto?.contracts[0]?.pivot?.ca_id != undefined
              ? parseFloat(produto?.contracts[0]?.pivot?.ca_id)
              : null,
          cofins:
            produto?.contracts[0]?.pivot?.cofins != undefined
              ? parseFloat(produto?.contracts[0]?.pivot?.cofins)
              : 0.0065,
          contract_product_description: produto.contract_product_description,
          icms:
            produto?.contracts[0]?.pivot?.icms != undefined
              ? parseFloat(produto?.contracts[0]?.pivot?.icms)
              : 0.18,
          isEpi: epi,
          pis:
            produto?.contracts[0]?.pivot?.pis != undefined
              ? parseFloat(produto?.contracts[0]?.pivot?.pis)
              : 0.03,
          product_category_id: parseFloat(categoriaId),
          product_id: produto.id,
        });
        quasar.notify({
          message: "Produto adicionado ao catálogo com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarCatalogo");
        selected.value = [];
        categoria.value = "";
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar produto no catálogo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = async () => {
      listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => filtros.value.busca,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(listarProdutos);
    onMounted(listarCategorias);

    return {
      columns,
      listarProdutos,
      filtros,
      listaProdutos,
      selected,
      listarCategorias,
      categorias,
      categoria,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      paginarTabela,
      disable,
      loading,
      adicionarProdutoCatalogo,
      categoriaGrid,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .select {
    width: 70px;
    outline: none;
  }
}
</style>
